export default "__VITE_ASSET__Djku6aLA__"